import React, { useState } from "react"
import { trackEvent } from '../utils/tracking'
import { Card } from "../components/ui/card"

const ReviewsDetails = ({
  website,
  affiliateLink,
  review,
  logo,
  code,
  rtp,
  games,
}) => {

  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!code) return
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch (e) {
      // ignore
    }
  }

  return (
    <Card className="!bg-[#0D0F11] border border-[#2A2D31]/40 overflow-hidden rounded-xl backdrop-blur-sm hover:shadow-[0_8px_30px_rgba(255,107,0,0.12)] transition-all duration-300">
      <div className="flex flex-col h-full">
        {/* Logo / Header */}
        <div className="relative w-full h-28 flex items-center justify-center bg-black">
          <img
            src={logo}
            alt={website}
            className="z-10 w-full h-full object-contain transition-transform duration-300"
          />
          <div className="z-0 absolute inset-0 bg-gradient-to-t from-[#00000070] to-transparent pointer-events-none" />
        </div>

        {/* Body */}
        <div className="flex flex-col flex-grow px-4 py-4">
          <div className="text-center">
            <h3 className="font-display text-base text-white font-semibold">{website}</h3>
          </div>

          <div className="mt-3 text-sm text-blue-100/70 min-h-[56px] text-center">
            {Array.isArray(review) ? (
              <ul className="space-y-2 list-none flex flex-col items-center">
                {review.map((item, idx) => (
                  <li key={`${website}-r-${idx}`} className="flex items-center gap-2">
                    <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-[#FF6B00]/10 text-[#FF9A3D] text-xs font-bold">✓</span>
                    <span className="text-sm leading-tight">{item}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="flex items-center justify-center gap-2">
                <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-[#FF6B00]/10 text-[#FF9A3D] text-xs font-bold">✓</span>
                <span className="text-sm leading-tight">{review}</span>
              </div>
            )}
          </div>

          {/* Code area */}
          <div className="mt-4 pt-4 border-t border-[#2A2D31]/30">
            <div className="p-3 bg-[#0F1215]/60 rounded-lg border border-[#2A2D31]/50 flex items-center gap-3">
              <div className="flex items-center justify-center gap-3 whitespace-nowrap w-full">
                <span className="text-xs text-gray-400">Use code</span>
                <div className="px-2 py-0.5 rounded-md bg-gradient-to-r from-[#FF6B00] to-[#FF9A3D] text-black text-sm font-medium flex-shrink-0">
                  {code}
                </div>
                <button
                  onClick={handleCopy}
                  className="px-2 py-1 rounded-md border border-[#2A2D31]/50 bg-[#0F1215]/50 text-sm text-blue-100/90 flex-shrink-0 whitespace-nowrap"
                >
                  {copied ? "Copied" : "Copy"}
                </button>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-4">
            <a
              href={affiliateLink}
              target="_blank"
              rel="noopener noreferrer"
              data-popup-gate="true"
              data-affiliate-outbound="true"
              data-affiliate-website={website}
              data-affiliate-code={code}
              className="inline-flex w-full items-center justify-center bg-gradient-to-r from-[#FF6B00] to-[#FF9A3D] hover:opacity-95 text-white rounded-md py-2 text-sm font-semibold text-center"
              onClick={() => { try { trackEvent('AffiliateClick', {website, url: affiliateLink, code}) } catch {} }}
            >
              CLAIM BONUS
            </a>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default ReviewsDetails
